import theme from '../../../lib/theme';

const {
  corners,
  scale,
  shadows,
  colors,
  media,
  layouts,
  font: {
    families,
    heights,

    ...font
  },
} = theme;

export default () => ({
  link: {
    textDecoration: 'none!important',

    '&:hover *': {
      textDecoration: 'none!important',
    },

    '&:hover .Holiday__title': {
      color: colors.sas.primary,
    },
  },

  tag: {
    display: 'inline-block',
    borderBottomRightRadius: corners.m,
    textTransform: 'uppercase',
    padding: `${scale.xxxxs} ${scale.xs}`,
    position: 'absolute',
    left: 0,
    top: 0,
    backgroundColor: colors.red,
    color: colors.white,
    fontFamily: families.primary,
    fontSize: font.l,
    fontWeight: font.bold,
    lineHeight: heights.xl,
  },

  category: {
    color: colors.sas.primary,
    fontFamily: families.primary,
    fontSize: font.l,
    fontWeight: font.bold,
    lineHeight: heights.l,
    textDecoration: 'none',
  },

  featuretext: {
    ...layouts.spacedColumn('xxs'),
    alignItems: 'flex-start',
    
    [media.l.up]: {
      flex: `1 0 calc(40% - ${scale.m})`,
      maxWidth: `40%`,
      
      '& > *': {
        width: '100%',
      },
    },
    
    '.content': {
      color: `${colors.black}!important`,

      'ul, ol': {
        paddingInlineStart: '20px',

        '> li': {
          color: `${colors.black}!important`,
        },
      },
    }
  },

  highlight: {
    backgroundColor: colors.tas.secondary,
    color: colors.black,
    fontSize: font.l,
    fontFamily: families.primary,
    lineHeight: heights.l,
    marginLeft: `-${scale.xxs}`,
    padding: `${scale.xxxs} ${scale.xxs}`,

    [media.l.up]: {
      width: 'auto',
    },
  },

  priceContainer: {
    ...layouts.spacedRow('xxxs'),

    alignitems: 'baseline',
  },

  subtitle: {
    fontFamily: families.primary,
    fontSize: font.m,
    lineHeight: heights.m,
    color: colors.black,
  },

  featureContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexDirection: 'column',
    gap: scale.xs,

    [media.l.up]: {
      flexDirection: 'row',
    },
  },

  featureImageContainer: {
    marginBottom: '0!important',
    position: 'relative',
    width: '100%',
    border: `1px solid ${colors.grey}`,
    flex: '1 0 auto',

    [media.l.up]: {
      flex: `0 0 calc(60% - ${scale.m})`,
      maxWidth: `60%`,
    },
  },

  featureImage: {
    width: '100%',
    display: 'block',
    objectFit: 'contain',
  },

  featuretitle: {
    color: colors.black,
    marginBottom: 0,
    transition: 'all 150ms linear',
    fontFamily: families.primary,
    fontSize: font.xl,
    fontWeight: font.normal,
    lineHeight: heights.xl,

    [media.l.up]: {
      fontSize: font.xxl,
      lineHeight: heights.xxl,
    },
  },

  featureprice: {
    color: colors.black,
    fontFamily: families.primary,
    fontSize: font.xxl,
    fontWeight: font.bold,
    lineHeight: heights.xxl,
    marginBottom: 0,
    transition: 'all 150ms linear',

    [media.l.up]: {
      fontSize: font.xxxl,
      lineHeight: heights.xxxl,
    },
  },
});
